import React, { useState, useEffect } from "react";
import { FaUserEdit, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import SelectBoxResponsavelCadastro from "../pages/SelectBoxResponsavelCadastro";
import "../css/ChecklistRotina.css";
import { useUser } from "../context/UserContext";
import { useRotinas } from "../context/RotinasContext";

const ChecklistRotina = ({ rotina, onClose, onSubmit }) => {
  const { userDecoded } = useUser();
  const { atualizarResponsavelRotina } = useRotinas();
  const [checklist, setChecklist] = useState(
    rotina.atividades.map((atividade) => ({
      id: atividade.id,
      nome: atividade.nome,
      finalizada: atividade.finalizada,
    }))
  );

  const [showEditarResponsavel, setShowEditarResponsavel] = useState(false);
  const [novoResponsavel, setNovoResponsavel] = useState(
    rotina.idResponsavel || ""
  );
  const [loadingResponsavel, setLoadingResponsavel] = useState(false);
  const [responsavelAtual, setResponsavelAtual] = useState(null);
  const perfisComAcessoEditar = ["DESENVOLVEDOR", "ADMIN", "GERENTE"];
  const podeEditarResponsavel = userDecoded()?.perfis?.some((perfil) =>
    perfisComAcessoEditar.includes(perfil)
  );

  useEffect(() => {
    if (rotina.responsavel) {
      setResponsavelAtual({
        value: rotina.idResponsavel,
        label: rotina.responsavel.nome,
      });
      setNovoResponsavel(rotina.idResponsavel);
    }
  }, [rotina]);

  const handleCheckboxChange = (itemId) => {
    setChecklist(
      checklist.map((item) =>
        item.id === itemId ? { ...item, finalizada: !item.finalizada } : item
      )
    );
  };

  const handleAtualizarResponsavel = async () => {
    if (!novoResponsavel) {
      toast.error("Selecione um responsável antes de salvar");
      return;
    }

    try {
      setLoadingResponsavel(true);
      const sucesso = await atualizarResponsavelRotina(
        rotina.id,
        novoResponsavel,
        rotina.idRestaurante
      );

      if (sucesso) {
        toast.success("Responsável atualizado com sucesso!");
        setShowEditarResponsavel(false);
        onClose();
      }
    } catch (error) {
      console.error("Erro ao atualizar responsável:", error);
      toast.error(error.message || "Erro ao atualizar responsável");
    } finally {
      setLoadingResponsavel(false);
    }
  };

  const handleSubmit = () => {
    const atividadesAtualizadas = checklist.map((item) => ({
      id: item.id,
      nome: item.nome,
      finalizada: item.finalizada,
    }));
    onSubmit(atividadesAtualizadas, rotina.id);
  };

  return (
    <div className="checklist-overlay">
      <div className="checklist-container">
        <div className="checklist-header">
          <div className="header-top">
            <h3>{rotina.descricao}</h3>
            <button onClick={onClose} className="close-button">
              <FaTimes />
            </button>
          </div>

          <div className="header-info">
            <span className="checklist-data">
              {new Date(rotina.data).toLocaleDateString("pt-BR")}
            </span>
            {responsavelAtual && (
              <span className="responsavel-atual">
                Responsável: {responsavelAtual.label}
              </span>
            )}
            {podeEditarResponsavel && (
              <button
                onClick={() => setShowEditarResponsavel(!showEditarResponsavel)}
                className="btn-editar-responsavel"
              >
                <FaUserEdit />{" "}
                {showEditarResponsavel ? "Cancelar" : "Editar Responsável"}
              </button>
            )}
          </div>
        </div>

        {showEditarResponsavel && (
          <div className="editar-responsavel-form">
            <div className="select-responsavel-container">
              <label>Selecione um responsável:</label>
              <SelectBoxResponsavelCadastro
                value={novoResponsavel}
                onChange={setNovoResponsavel}
              />
            </div>
            <div className="form-actions">
              <button
                onClick={() => setShowEditarResponsavel(false)}
                className="btn-cancelar"
              >
                Cancelar
              </button>
              <button
                onClick={handleAtualizarResponsavel}
                disabled={loadingResponsavel || !novoResponsavel}
                className="btn-primario"
              >
                {loadingResponsavel ? "Salvando..." : "Salvar"}
              </button>
            </div>
          </div>
        )}

        <div className="checklist-scrollable">
          <div className="checklist-items">
            {checklist.map((item) => (
              <div key={item.id} className="checklist-item">
                <input
                  type="checkbox"
                  id={`item-${item.id}`}
                  checked={item.finalizada}
                  onChange={() => handleCheckboxChange(item.id)}
                />
                <label
                  htmlFor={`item-${item.id}`}
                  className={item.finalizada ? "concluido" : "pendente"}
                >
                  {item.nome}
                </label>
                <span
                  className={
                    item.finalizada ? "status-concluido" : "status-pendente"
                  }
                >
                  {item.finalizada ? "Concluído" : "Pendente"}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="checklist-actions">
          <button onClick={onClose} className="btn-secundario">
            Fechar
          </button>
          <button onClick={handleSubmit} className="btn-primario">
            Salvar Alterações
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChecklistRotina;
